import { render, staticRenderFns } from "./meal-categories.vue?vue&type=template&id=29273f9f&scoped=true"
import script from "./meal-categories.vue?vue&type=script&lang=js"
export * from "./meal-categories.vue?vue&type=script&lang=js"
import style0 from "./meal-categories.vue?vue&type=style&index=0&id=29273f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29273f9f",
  null
  
)

export default component.exports